import { AlertCircle, Phone, RefreshCw } from "lucide-react";
import { FLOW_BUTTON_CLASS, FlowButton, FlowPanel } from "./FlowPanel";

interface PaymentErrorViewProps {
  /** The message the page received; shown under "What happened". */
  error: string;
  onRetry?: () => void;
  /** Fleet phone for the "Call the fleet" link. Omitted when empty. */
  phone?: string | null;
}

export function PaymentErrorView({
  error,
  onRetry,
  phone,
}: PaymentErrorViewProps) {
  return (
    <FlowPanel
      kicker="Payment error"
      title="Your payment did not go through"
      icon={
        <div
          aria-hidden="true"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-white ring-1 ring-[#e6e7e8]"
        >
          <AlertCircle className="h-7 w-7 text-[#b42318]" />
        </div>
      }
    >
      <div className="mx-auto max-w-xl">
        <div
          role="alert"
          className="rounded-xl border border-[#f3c7c2] bg-[#fdecea] p-5"
        >
          <span className="mb-1 block font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-[#b42318]">
            What happened
          </span>
          <p className="text-sm text-[#06131b]">{error}</p>
        </div>

        <div className="mt-6 flex flex-col items-center gap-3">
          <FlowButton onClick={onRetry}>
            <RefreshCw className="h-5 w-5" aria-hidden="true" />
            Try again
          </FlowButton>
          {phone && (
            <a
              href={`tel:${phone}`}
              className={`${FLOW_BUTTON_CLASS} !bg-white !text-[#00695e] ring-1 ring-[#e6e7e8] hover:!bg-[#e6f4f2]`}
            >
              <Phone className="h-5 w-5" aria-hidden="true" />
              Call the fleet · {phone}
            </a>
          )}
        </div>
      </div>
    </FlowPanel>
  );
}
